export default (entity = {}) => {
    return {
        id: entity.id || undefined,
        recipientUserId: entity.recipientUserId || null,
        budgetOnly: entity.hasOwnProperty('budgetOnly') ? entity.budgetOnly : true,
        useOnce: entity.hasOwnProperty('useOnce') ? entity.useOnce : true,
    };
};
